// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M48t","col":"styles_col__2ED-v","actions":"styles_actions__JGyCF","conflict":"styles_conflict__3tsOW"};